'use client';

import React from 'react';

interface TicketMetrics {
  totalTickets: number;
  totalTicketTimeHours: string;
  averageTicketTimeMinutes: string;
  averageWaitingTimeMinutes: string;
  averageMessagingTimeMinutes: string;
  averageTransferCount: number;
}

export function TicketEffortAnalysis({ 
  metrics, 
  loading = false 
}: { 
  metrics: TicketMetrics | null; 
  loading?: boolean;
}) {
  if (loading) {
    return (
      <div className="bg-slate-900/50 backdrop-blur border border-slate-700/50 rounded-lg p-6" style={{ padding: '1em' }}>
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-slate-700 rounded w-1/3"></div>
          <div className="grid grid-cols-2 gap-4">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-20 bg-slate-700 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!metrics) {
    return (
      <div className="bg-slate-900/50 backdrop-blur border border-slate-700/50 rounded-lg p-6 text-center">
        <p className="text-slate-400">No ticket data available</p>
      </div>
    );
  }

  return (
    <div className="space-y-6" >
      <div className="bg-slate-900/50 backdrop-blur border border-slate-700/50 rounded-lg p-6"  style={{ padding: '1em' }}>
        <h3 className="text-xl font-semibold text-slate-100 mb-6" style={{ marginBottom: '1em' }}>Análise de Esforço em Tickets</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" >
          {/* Total Tickets */}
          <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50" style={{ padding: '1em' }}>
            <p className="text-slate-400 text-sm font-medium mb-2">Total de Tickets</p>
            <p className="text-3xl font-bold text-blue-400">{metrics.totalTickets}</p>
          </div>

          {/* Total Time */}
          {/* <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50">
            <p className="text-slate-400 text-sm font-medium mb-2">Tempo Total em Tickets</p>
            <p className="text-3xl font-bold text-green-400">{metrics.totalTicketTimeHours}h</p>
          </div> */}

          {/* Average Ticket Time */}
          <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50" style={{ padding: '1em' }}>
            <p className="text-slate-400 text-sm font-medium mb-2">Tempo Médio por Ticket</p>
            <p className="text-3xl font-bold text-yellow-400">{metrics.averageTicketTimeMinutes} mins</p>
          </div>

          {/* Average Waiting Time */}
          <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50" style={{ padding: '1em' }}>
            <p className="text-slate-400 text-sm font-medium mb-2">Tempo Médio de Espera</p>
            <p className="text-3xl font-bold text-purple-400">{metrics.averageWaitingTimeMinutes} mins</p>
          </div>

          {/* Average Messaging Time */}
          <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50" style={{ padding: '1em' }}>
            <p className="text-slate-400 text-sm font-medium mb-2">Tempo Médio de Mensagem</p>
            <p className="text-3xl font-bold text-pink-400">{metrics.averageMessagingTimeMinutes} mins</p>
          </div>

          {/* Average Transfers */}
          {/* <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50">
            <p className="text-slate-400 text-sm font-medium mb-2">Transferências Médias</p>
            <p className="text-3xl font-bold text-orange-400">{metrics.averageTransferCount}</p>
          </div> */}
        </div>
      </div>

      <div className="bg-slate-900/50 backdrop-blur border border-slate-700/50 rounded-lg p-6" style={{ padding: '1em', marginTop: '1em', marginBottom: '1em'  }}>
        <h4 className="text-lg font-semibold text-slate-100 mb-4">Insights</h4>
        <ul className="space-y-3 text-slate-300">
          <li className="flex items-start">
            <span className="text-blue-400 mr-3">•</span>
            <span>Total de {metrics.totalTickets} tickets fechados no período</span>
          </li>
          <li className="flex items-start">
            <span className="text-green-400 mr-3">•</span>
            <span>{metrics.totalTicketTimeHours} horas gastas em tickets</span>
          </li>
          <li className="flex items-start">
            <span className="text-yellow-400 mr-3">•</span>
            <span>Média de {metrics.averageTicketTimeMinutes} minutos por ticket</span>
          </li>
          <li className="flex items-start">
            <span className="text-purple-400 mr-3">•</span>
            <span>{metrics.averageTransferCount} transferências em média por ticket</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
